import type { ChatConfiguration } from '../types/chat';
import type { ChatServiceConfiguration } from './chatService';

export function normalizeChatConfiguration(config?: ChatConfiguration): ChatServiceConfiguration | null {
    if (!config) {
        return null;
    }

    if (typeof config === 'string') {
        const endpoint = config.trim();
        return endpoint.length ? { endpoint } : null;
    }

    const endpoint = config.endpoint?.trim();
    if (!endpoint) {
        return null;
    }

    const headers = config.headers
        ? Object.keys(config.headers)
              .filter((key) => Boolean(config.headers?.[key]))
              .sort()
              .reduce<Record<string, string>>((acc, key) => {
                  const value = config.headers?.[key];
                  if (value) {
                      acc[key] = value;
                  }
                  return acc;
              }, {})
        : undefined;

    return {
        endpoint,
        feedbackEndpoint: config.feedbackEndpoint,
        headers,
        agentId: config.agentId,
        getAuthorizationToken: config.getAuthorizationToken,
        onEnrichContext: config.onEnrichContext
    };
}
